import { FormikHelpers } from 'formik';
import { regNewUser } from '../../../../../../../api/auth/register';
import { ResponseError } from '../../../../../../../api/error';
import { useTranslation } from '../../../../../../../i18n/use-translation';
import { useErrorHandler } from '../../../../../../hooks/use-error-handler';
import { useRequest } from '../../../../../../hooks/use-request';
import { RegisterData } from '../../../../../../type/register-data';

type Params = {
  submitHandler: (data: RegisterData) => void;
};

export function useViewModel(params: Params) {
  const { locale } = useTranslation();
  const errorHandler = useErrorHandler();
  const { isLoading, action } = useRequest();

  const submitHandler = (data: RegisterData, formik: FormikHelpers<RegisterData>) =>
    action(async () => {
      try {
        await regNewUser(locale, { ...data });
        params.submitHandler(data);
      } catch (e) {
        errorHandler<RegisterData>(e as ResponseError, formik);
      }
    });

  return {
    isLoading,
    submitHandler,
  };
}
